import { useState } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import CircleButton from '../circleButton/circleButton';
import { useTranslation } from 'react-i18next';

// import ExampleCarouselImage from 'components/ExampleCarouselImage';
import "./greetingCarousel.css"
function GreetingCarousel({itemOptions}) {
    const { t } = useTranslation("translation", {keyPrefix: "greetingCarousel"});
    const [index, setIndex] = useState(0);

    const handleSelect = (selectedIndex) => {
        setIndex(selectedIndex);
    };
    const clickableItems = []
    const colorOptions = [
        getComputedStyle(document.body).getPropertyValue('--button-pink'),
        // getComputedStyle(document.body).getPropertyValue('--unity-primary-blue'),
        // getComputedStyle(document.body).getPropertyValue('--unity-secondary-yellow'),
        // getComputedStyle(document.body).getPropertyValue('--unity-primary-violet'),
        // getComputedStyle(document.body).getPropertyValue('--unity-secondary-violet'),
        // getComputedStyle(document.body).getPropertyValue('--unity-secondary-pink'),
    ]
    let threestack = []
    let colorChoice = 0
    const stackIt = () => {
        clickableItems.push(<Carousel.Item><div className='carousel-div'>{threestack}</div></Carousel.Item>)
        threestack = []
    }
    for(let i in itemOptions){
        threestack.push(<CircleButton onClick={itemOptions[i]?.onClick} style={{backgroundColor: itemOptions[i]?.color ? itemOptions[i]?.color : colorOptions[colorChoice]}} secondLine={itemOptions[i]?.text2 ? itemOptions[i]?.text2.toUpperCase() : null}>{itemOptions[i].text.toUpperCase()}</CircleButton>)
        if(threestack.length === 3){
            stackIt()
        }
        if(colorChoice < colorOptions.length - 1){
            colorChoice++
        }else{
            colorChoice = 0
        }
    }
    if(threestack.length > 0){
        stackIt()
    }

    return (
        <Carousel activeIndex={index} onSelect={handleSelect} className='tan-carousel' data-bs-theme="dark">
            {clickableItems}
        </Carousel>
    );
}

export default GreetingCarousel;